{
	"title": "Transactie niet gevonden",
	"description": "Ga naar het overzicht en voer een geldige transactie-ID in. Een transactie-ID is te vinden op een verklaring of op een factuur.",
	"secondaryButtonTitle": "Startpagina tonen"
}
